// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tooltip{display:block;z-index:50;margin-left:1rem}.tooltip-inner{--bg-opacity:1;background-color:#9dd5c9;background-color:rgba(157,213,201,var(--bg-opacity));--text-opacity:1;color:#fff;color:rgba(255,255,255,var(--text-opacity));padding:2rem;margin-top:-1rem;max-width:75%;-webkit-clip-path:polygon(0 5%,100% 0,100% 100%,0 95%);clip-path:polygon(0 5%,100% 0,100% 100%,0 95%)}@media (min-width:768px){.tooltip-inner{margin-top:0;max-width:25vw}}.tooltip-arrow{display:none}", ""]);
// Exports
module.exports = exports;
